import { routes } from "router";

export const getRouteMap = () => ({
  deactivated: {
    details: routes.proEditExperienceDeactivateBackRoutePathDetails,
    scheduling: routes.proEditExperienceDeactivateBackRoutePathScheduling,
    media: routes.proEditExperienceDeactivateBackRoutePathMedia,
    resources: routes.proEditExperienceDeactivateBackRoutePathResources,
    location: routes.proEditExperienceDeactivateBackRoutePathLocation,
    digital_waiver: routes.proEditExperienceDeactivateBackRoutePathDigitalWaiver,
    tax_fees: routes.proEditExperienceDeactivateBackRoutePathTaxFees,
    preview: routes.proEditExperienceDeactivateBackRoutePathPreview,
    default: routes.proExperiencePathDeactivatedPath,
  },
  published: {
    details: routes.proEditExperiencePublishBackRoutePathDetails,
    scheduling: routes.proEditExperiencePublishBackRoutePathScheduling,
    media: routes.proEditExperiencePublishBackRoutePathMedia,
    resources: routes.proEditExperiencePublishBackRoutePathResources,
    location: routes.proEditExperiencePublishBackRoutePathResLocation,
    digital_waiver: routes.proEditExperiencePublishBackRoutePathDigitalWaiver,
    tax_fees: routes.proEditExperiencePublishBackRoutePathTaxFees,
    preview: routes.proEditExperiencePublishBackRoutePathResPreview,
    default: routes.proExperiencePathPublishedPath,
  },
  draft: {
    details: routes.proEditExperienceDraftBackRoutePathDetails,
    scheduling: routes.proEditExperienceDraftBackRoutePathScheduling,
    media: routes.proEditExperienceDraftBackRoutePathMedia,
    resources: routes.proEditExperienceDraftBackRoutePathResources,
    location: routes.proEditExperienceDraftBackRoutePathLocation,
    digital_waiver: routes.proEditExperienceDraftBackRoutePathDigitalWaiver,
    tax_fees: routes.proEditExperienceDraftBackRoutePathTaxFees,
    preview: routes.proEditExperienceDraftBackRoutePathPreview,
    default: routes.proExperiencePathDraft,
  },
  create: {
    details: routes.proNewListingDetailsPath,
    scheduling: routes.proNewListingSchedulingPath,
    media: routes.proNewListingMediaPath,
    resources: routes.proNewListingResourcesPath,
    location: routes.proNewListingLocationPath,
    digital_waiver: routes.proNewListingDigitalWaiverPath,
    tax_fees: routes.proNewListingTaxFeesPath,
    preview: routes.proNewListingPreviewPath,
    default: routes.proNewListingRootPath,
  },
});
